import type { Theme } from '@emotion/react';
import IconButton from '@mui/material/IconButton';
import { type SxProps, useTheme } from '@mui/material/styles';

import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint';
import { Button } from '../Button/Button';

export const ExpandableIconButton = ({
  icon,
  label,
  onClick,
  sx,
}: {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  sx?: SxProps<Theme>;
}) => {
  const { isMobile } = useBreakpoint();
  const theme = useTheme();
  return isMobile ? (
    <IconButton
      onClick={onClick}
      size="large"
      sx={{
        '&:hover': {
          bgcolor: theme.palette.layout[200],
        },
        bgcolor: 'white',
        border: `1px solid ${theme.palette.border.main}`,
        borderRadius: 2,
        color: 'black',
        ...sx,
      }}
    >
      {icon}
    </IconButton>
  ) : (
    <Button onClick={onClick} variant="secondary" startIcon={icon} size="large" sx={sx}>
      {label}
    </Button>
  );
};
